import { getAnalytics, isSupported, logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import { app } from '../firebase/firebase';

let analyticsPromise = null;

function getInstance() {
  if (analyticsPromise) return analyticsPromise;
  analyticsPromise = isSupported()
    .then((ok) => (ok ? getAnalytics(app) : null))
    .catch(() => null);
  return analyticsPromise;
}

export async function track(eventName, params) {
  try {
    const a = await getInstance();
    if (!a) return;
    logEvent(a, eventName, params || {});
    if (import.meta.env.DEV) {
      console.log(`[analytics] ${eventName}`, params || '');
    }
  } catch {
  }
}

export async function identify(userId, properties) {
  try {
    const a = await getInstance();
    if (!a) return;
    if (userId) setUserId(a, userId);
    if (properties) setUserProperties(a, properties);
  } catch {
  }
}

export const ACTIVATION_EVENTS = {
  TEAM_CREATED: 'activation_team_created',
  ROSTER_ADDED: 'activation_roster_added',
  SEASON_CREATED: 'activation_season_created',
  STAFF_INVITED: 'activation_staff_invited',
  CHECKLIST_ITEM_CLICKED: 'activation_checklist_item_clicked',
  CHECKLIST_DISMISSED: 'activation_checklist_dismissed',
};
